module.exports = __webpack_public_path__ + "img/tooth15.e5bc4a54.png";